"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVOICE_DOCUMENT_KINDS = void 0;
/**
 * "customer"/"shop" distinguish the two copies `GET
 * /invoices/:invoiceId/documents/:kind` can render (see
 * InvoiceRenderingService) — a PDF is rendered fresh on every call and
 * never persisted (see docs/TRAPS.md), so there's no longer any
 * JSON-serializable "document" metadata to describe; this pair of
 * constants is the only thing left from that shape.
 */
exports.INVOICE_DOCUMENT_KINDS = ["customer", "shop"];
//# sourceMappingURL=documents.js.map